// test1869
(1869 && 0);
